var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#6D727F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.076,
    width: 8.4,
    height: 10.8,
    rx: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.115 8.943c0-.52.422-.943.943-.943H19a1.2 1.2 0 011.2 1.2v9.071a.528.528 0 01-.528.529h0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgCopyGrey;